module.exports = __webpack_public_path__ + "static/media/haiwaizhengcheyewuliucheng.74a6503b.png";